import React, { useEffect, useState } from 'react';
import { Slide } from 'react-reveal';
import AdmissionCourseAnimations from '../../../PowerFullAnimation/AdmissionCourseAnimations';
import LiveCourseCart from './LiveCourseCart';
import PopularCourseCartAimation from '../../../PowerFullAnimation/PopularCourseCartAimation';


const LiveCourse = () => {

    const [course, setCourse] = useState([]);
    const [loadding, setLoadding] = useState(true);


    useEffect(() => {
        fetch('https://one0m-backend2.onrender.com/freePaid')
            .then(res => res.json())
            .then(data => {
                setCourse(data?.freePaidData);
                setLoadding(false);
            })
            .catch(err => {
                setLoadding(true)
            })
    }, [course])

    return (
        <div className='bg-light p-5 container-fluid' style={{ borderRadius: '10px' }}>
            <div className="course-title text-center mt-5 mb-5">
                <Slide right>
                    <h3 className='fw-bold mb-2 fs-2'>স্পেশাল লাইভ কোর্স</h3>
                </Slide>
            </div>
            <div className="course-data">
                <div className="row gy-4">
                    {
                        course.map(course => <LiveCourseCart course={course} />)
                    }
                </div>
            </div>
            <div className="setLoadding">
                {
                    loadding ? <>
                        <PopularCourseCartAimation />
                    </>
                        : ''
                }
            </div>
        </div>
    );
};

export default LiveCourse;